import { z } from 'zod';

export const zodInvoiceAiModelsSearchParametersSchema = z.object({
  page: z.coerce.number().nonnegative().optional().prefault(0).catch(0),
  searchString: z.string().optional().prefault(''),
});

export type InvoiceAiModelsSearchParameters = z.infer<
  typeof zodInvoiceAiModelsSearchParametersSchema
>;
